<script setup lang="ts">
import AppInfoBox from '../molecules/app/AppInfoBox.vue';
import { useInjectedErrors } from '../../composables/use-injected-errors';

const { general: errors } = useInjectedErrors();

function reloadPage() {
    window.location.reload();
}
</script>

<template>
    <AppInfoBox
        v-if="errors.messages.length"
        error
        data-qa="general error box"
    >
        <ul>
            <li
                v-for="message in errors.messages"
                :key="message"
                data-qa="error message"
            >
                {{ message }}
            </li>
        </ul>
        <button
            v-if="errors.recommendedActions.includes('reload')"
            class="underline"
            type="button"
            data-qa="action: reload"
            @click="reloadPage"
        >
            Seite neu laden
        </button>
    </AppInfoBox>
</template>
